// Guarded sessionStorage access: returns/no-ops on the server (SSR) and when
// sessionStorage throws (private mode, storage disabled) instead of crashing.

export const safeSessionGet = (key: string): string | null => {
	if (typeof window === 'undefined') {
		return null;
	}

	try {
		return sessionStorage.getItem(key);
	} catch {
		return null;
	}
};

export const safeSessionSet = (key: string, value: string): void => {
	if (typeof window === 'undefined') {
		return;
	}

	try {
		sessionStorage.setItem(key, value);
	} catch {
		// sessionStorage unavailable; callers are expected to degrade gracefully.
	}
};

export const safeSessionRemove = (key: string): void => {
	if (typeof window === 'undefined') {
		return;
	}

	try {
		sessionStorage.removeItem(key);
	} catch {
		// no-op
	}
};
